var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateToast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "#D5D5D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 43738"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44.5,
    y: -284.5,
    width: 542,
    height: 511,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant4",
    filter: "url(#filter0_d_8099_76293)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8099_76293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -15,
    width: 419,
    height: 82,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 43743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 43742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 43739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0.5C5.59644 0.5 0 6.09644 0 13C0 19.9035 5.59644 25.5 12.5 25.5C19.4035 25.5 25 19.9035 25 13C25 6.09644 19.4035 0.5 12.5 0.5ZM11.9318 6.18182C11.3042 6.18182 10.7955 6.69059 10.7955 7.31818C10.7955 7.94577 11.3042 8.45455 11.9318 8.45455H12.5C13.1276 8.45455 13.6364 7.94577 13.6364 7.31818C13.6364 6.69059 13.1276 6.18182 12.5 6.18182H11.9318ZM10.2273 10.7273C9.59967 10.7273 9.09091 11.236 9.09091 11.8636C9.09091 12.4913 9.59967 13 10.2273 13H11.3636V16.4091H10.2273C9.59967 16.4091 9.09091 16.9178 9.09091 17.5455C9.09091 18.1731 9.59967 18.6818 10.2273 18.6818H14.7727C15.4003 18.6818 15.9091 18.1731 15.9091 17.5455C15.9091 16.9178 15.4003 16.4091 14.7727 16.4091H13.6364V11.8636C13.6364 11.236 13.1276 10.7273 12.5 10.7273H10.2273Z",
    fill: "#175FEF"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8099_76293",
    x: -24,
    y: -19,
    width: 427,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8099_76293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8099_76293",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8099_76293"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -15,
    width: 419,
    height: 82,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateToast);
export default __webpack_public_path__ + "static/media/update-toast.3e685e3f2438a2724cd8cb69c22eed8c.svg";
export { ForwardRef as ReactComponent };